export const useHelpers = () => {
    
    const getBodyForTransferToCentral = (FormScreen, user) => {
        
        return {
            idgestion: FormScreen.formState.idgestion,
            idgestiontipo: FormScreen.formState.idgestiontipo,
            idcaja: FormScreen.formState.idcaja,
            idusuario: user.uid,
            monto_solicitado: FormScreen.formState.monto_solicitado,
            idcaja_destino: FormScreen.formState.idcaja_destino,
            descripcion: FormScreen.formState.descripcion,
            user: user.username,
            aprobacion_check: 'Pendiente Aprobacion'
        }
    }
    
    const getBodyForTransferToBank = (FormScreen, user) => {

        // Validamos si es primera o segunda vuelta
        const prepare_aprobacion_check = FormScreen.formState.aprobacion_check === 'Traslado Aprobado'
            ? 'Revisión de Depósito'
            : 'Pendiente Aprobacion'
        
        const _data = new FormData();        
        _data.append('idgestion', FormScreen.formState.idgestion)
        _data.append('idgestiontipo', FormScreen.formState.idgestiontipo)
        _data.append('idcaja', FormScreen.formState.idcaja)
        _data.append('idusuario', user.uid)
        _data.append('monto_solicitado', FormScreen.formState.monto_solicitado)
        _data.append('idbanco', FormScreen.formState.idbanco)
        _data.append('numero_comprobante', FormScreen.formState.numero_comprobante)
        _data.append('descripcion', FormScreen.formState.descripcion)
        _data.append('user', user.username)
        _data.append('aprobacion_check', prepare_aprobacion_check)


        FormScreen.formState.acceptedFiles.forEach((file, index) => {
            _data.append(`images`, file);
        });

        return _data
        
        // return {
        //     idgestion: FormScreen.formState.idgestion,
        //     idgestiontipo: FormScreen.formState.idgestiontipo,
        //     idcaja: FormScreen.formState.idcaja,
        //     idusuario: user.uid,
        //     monto_solicitado: FormScreen.formState.monto_solicitado,
        //     idbanco: FormScreen.formState.idbanco,
        //     numero_comprobante: FormScreen.formState.numero_comprobante,
        //     descripcion: FormScreen.formState.descripcion,
        //     user: user.username,
        //     aprobacion_check: prepare_aprobacion_check
        // }
    }

    const getBodyForCashReceipt = (FormScreen, user) => {
        
        return {
            idgestion: FormScreen.formState.idgestion,
            idgestiontipo: FormScreen.formState.idgestiontipo,
            idcaja: FormScreen.formState.idcaja,
            idusuario: user.uid,
            monto_solicitado: FormScreen.formState.monto_solicitado,
            descripcion: FormScreen.formState.descripcion,
            user: user.username,
            aprobacion_check: 'Aprobado',
            aprobacion_observaciones: 'Aprobado en automático, gestión no requiere de revisión administrativa'
        }
    }
    
    const getBodyForCashRefill = (FormScreen, user) => {

        const prepare_aprobacion_check = FormScreen.formState.aprobacion_check === 'Esperando Reintegro'
            ? 'Aprobado'
            : 'Pendiente Aprobacion'

        return {
            idgestion: FormScreen.formState.idgestion,
            idgestiontipo: FormScreen.formState.idgestiontipo,
            idcaja: FormScreen.formState.idcaja,
            idusuario: user.uid,
            monto_solicitado: FormScreen.formState.monto_solicitado,
            monto_aprobado: FormScreen.formState.monto_aprobado,
            descripcion: FormScreen.formState.descripcion,
            user: user.username,
            aprobacion_check: prepare_aprobacion_check
        }
    }

    const _multipartServicePayment = (payload) => {
        
        const _data = new FormData();    
        
        _data.append('idgestion', payload.idgestion)
        _data.append('idgestiontipo', payload.idgestiontipo)
        _data.append('idcaja', payload.idcaja)
        _data.append('idusuario', payload.idusuario)
        _data.append('monto_solicitado', payload.monto_solicitado)
        _data.append('numero_comprobante', payload.numero_comprobante)
        _data.append('numero_serie_factura', payload.numero_serie_factura)
        _data.append('descripcion_servicio', payload.descripcion_servicio)
        _data.append('limite_pago_servicio', payload.limite_pago_servicio)
        _data.append('anular_pago_servicio', payload.anular_pago_servicio)
        _data.append('descripcion', payload.descripcion)
        _data.append('user', payload.user)
        _data.append('aprobacion_check', payload.aprobacion_check)
        payload.acceptedFiles.forEach((file, index) => {
            _data.append(`images`, file);
        });

        return _data
    }
    
    const getBodyForServicePayment = (FormScreen, user) => {

        const { monto_solicitado, limite_pago_servicio } = FormScreen.formState || {}
        const requiresAdministrativeApproval = parseFloat(monto_solicitado) > parseFloat(limite_pago_servicio)
        const preparedAprobacionCheck = FormScreen.formState.aprobacion_check === 'Pago Aprobado'
            ? 'Revision Comprobante'
            : requiresAdministrativeApproval
                ? 'Pendiente Aprobacion'
                : 'Aprobado'
        
        const preparedPayload =  {
            idgestion: FormScreen.formState.idgestion,
            idgestiontipo: FormScreen.formState.idgestiontipo,
            idcaja: FormScreen.formState.idcaja,
            idusuario: user.uid,
            monto_solicitado: FormScreen.formState.monto_solicitado,
            numero_comprobante: FormScreen.formState.numero_comprobante,
            numero_serie_factura: FormScreen.formState.numero_serie_factura,
            descripcion_servicio: FormScreen.formState.descripcion_servicio,
            limite_pago_servicio: FormScreen.formState.limite_pago_servicio,
            anular_pago_servicio: FormScreen.formState.anular_pago_servicio,
            acceptedFiles: FormScreen.formState.acceptedFiles,
            descripcion: FormScreen.formState.descripcion,
            user: user.username,
            aprobacion_check: preparedAprobacionCheck
        }

        return _multipartServicePayment(preparedPayload)
        
    }

    const getBodyBuyingSellingDollars = (FormScreen, user) => {
        
        return {
            idgestion: FormScreen.formState.idgestion,
            idgestiontipo: FormScreen.formState.idgestiontipo,
            idcaja: FormScreen.formState.idcaja,
            idusuario: user.uid,
            monto_solicitado: FormScreen.formState.monto_solicitado,
            tipo_cambio: FormScreen.formState.tipo_cambio,
            monto_convertido: FormScreen.formState.monto_convertido,
            idcaja_destino: FormScreen.formState.idcaja_destino,
            descripcion: FormScreen.formState.descripcion,
            user: user.username,
            aprobacion_check: 'Aprobado'
        }
    }
    
    return Object.freeze({
        getBodyForTransferToCentral,
        getBodyForTransferToBank,
        getBodyForCashReceipt,
        getBodyForCashRefill,
        getBodyForServicePayment,
        getBodyBuyingSellingDollars
    })
}